import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { MatTableDataSource } from '@angular/material/table'
import { ActivatedRoute, Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { NotificationService } from '../../../../../../notification/shared/notification.service'
import { BasketService } from '../../../../../basket/shared/basket.service'
import { Client } from '../../../../../shared/client/client'
import { ClientService } from "../../../../../shared/client/client.service"
import { ContratService } from '../../../../../shared/client/contrat/contrat.service'
import { SideBarService } from '../../../../../shared/sidebar/side-bar.service'
import { ArticlePorteur } from '../../../shared/articles/article'
import { Porteur } from '../../../shared/porteur'

@Component({
  selector: 'app-edit',
  templateUrl: './edit-dotation.component.html',
  styleUrls: ['./edit-dotation.component.scss']
})
export class EditDotationComponent implements OnInit, OnDestroy {

  article: ArticlePorteur
  dataSource: MatTableDataSource<Object> = new MatTableDataSource<Object>()
  // Colonnes
  columns = [
    { id: 'dernierLavage', libelle: 'Dernière livraison prévue' },
    { id: 'jeu', libelle: 'Jeu' },
    { id: 'numCab', libelle: 'ID Vts' },
    { id: 'nbLavage', libelle: 'Nb lavage' },
    { id: 'statutVT', libelle: 'Action' },
  ]
  displayedColumns: Array<string> = ['dernierLavage', 'statutVT', 'numCab', 'jeu']
  client: Client = null
  load: Subscription = new Subscription()
  selected = null
  selected_value = null
  taille: string
  tailles
  indexTaille: number = 0
  defaultIndex: number = 0
  changes
  porteur: Porteur
  precision: string

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private basketService: BasketService,
    private contratService: ContratService,
    private notificationService: NotificationService,
    protected sideBarService: SideBarService,
    private clientService: ClientService
  ) { }

  ngOnInit() {
    this.getPorteur()
    this.getArticle()
    if (this.article.isEpi) {
      this.displayedColumns.push('nbLavage')
    }
  }

  ngOnDestroy() {
    this.load.unsubscribe()
  }

  getPorteur() {
    this.route.parent.parent.data.subscribe(data => {
      this.porteur = data.porteur
    })
  }

  getArticle() {
    this.route.data.subscribe(data => {
      this.article = data.article
      this.load = this.contratService.getTailles(data.article).subscribe(res => {
        for (let taille in res) {
          if (data.article.taille == res[taille].cle_ref) {
            this.indexTaille = parseInt(taille)
            this.defaultIndex = parseInt(taille)
            break
          }
        }
        this.tailles = res
      })
      this.contratService.getChanges(data.article).subscribe(res => {
        this.changes = res
      })
      this.taille = data.article.taille
      data.cab = data.cab.map(function (mappedCab) {
        let value = ''
        switch (mappedCab.statutVT) {
          case 'C': {
            if (mappedCab.echange == 1) {
              value = "EN ATTENTE D'ECHANGE";
            } else {
              value = 'ECHANGE';
            }
            break;
          }
          case 'L': {
            value = 'RELAVAGE'
            break
          }
          case 'M': {
            value = 'REMARQUAGE'
            break
          }
          case 'S': {
            value = 'LIVRAISON'
            break
          }
          case 'R': {
            value = 'RETOUCHE';
            break;
          }
          case 'Y': {
            value = 'ECARTE';
            break;
          }
          case 'E': {
            value = 'EN USINE';
            break;
          }
          default: {
            break
          }
        }
        mappedCab.statutVT = value
        return mappedCab
      })
      this.dataSource.data = data.cab
      this.precision = data.article.precision
    })
  }

  inc() {
    if (this.tailles[this.indexTaille + 1]) {
      this.indexTaille++
      this.taille = this.tailles[this.indexTaille].libelle_court
    }
  }

  dec() {
    if (this.tailles[this.indexTaille - 1]) {
      this.indexTaille--
      this.taille = this.tailles[this.indexTaille].libelle_court
    }
  }

  changePrecision(event) {
    let changePrecision = event.target.value.replace(/[\u2200-\u227F]/g, '')
    if (event.target.value != changePrecision) {
      event.target.value = changePrecision
      this.notificationService.notif("Insertion d'un caractère spécial non géré : unicode 2200 à 227F interdits", 'warn')
    }
    this.precision = changePrecision
  }

  demandeChangement() {
    if (this.editDotationForm.get('qteSouhaite').hasError('required')) {
      this.notificationService.notif('Vous devez renseigner la quantité souhaitée car la règle de facturation est de type Stock ou Réel', 'error')
    } else {
      this.precision = this.precision ?? ''
      if (this.taille != this.article.taille) {
        this.basketService.addBasketLine({
          type: 'CHANGEMENT DE TAILLE',
          numPorteur: this.porteur.numPorteur,
          newTaille: this.taille,
          article: this.article.code_article,
          taille: this.article.taille,
          newPrecision: this.precision,
          codeService: this.clientService.modifCodeService
        }).subscribe(res => {
          this.success('Changement de taille')
          this.closeSlideBar()
        })
      }
      if (this.selected != null && this.article.change + '/' + this.article.stock !== this.selected.split('|')[0]) {
        this.basketService.addBasketLine({
          type: 'CHANGEMENT DE DOTATION',
          numPorteur: this.porteur.numPorteur,
          newRegle: this.selected.split(':')[0],
          article: this.article.code_article,
          taille: this.article.taille,
          newPrecision: this.precision,
          codeService: this.clientService.modifCodeService,
          qteSouhaite: this.selected_value,
          regleFactu: this.selected.split(':')[1]
        }).subscribe(res => {
          this.success('Changement de dotation')
          this.closeSlideBar()
        })
      }
      if ((this.precision != null && this.precision !== '') && this.taille == this.article.taille && (this.selected == null || this.article.change + '/' + this.article.stock === this.selected.split('|')[0])) {
        this.basketService.addBasketLine({
          type: 'COMMENTAIRE UTILISATEUR',
          numPorteur: this.porteur.numPorteur,
          article: this.article.code_article,
          newPrecision: this.precision,
          taille: this.article.taille,
          codeService: this.clientService.modifCodeService
        }).subscribe(res => {
          this.success('Commentaire Utilisateur')
          this.closeSlideBar()
        })
      }
    }
  }

  private success(message: string) {
    this.notificationService.notif("Votre demande de " + message + " a été ajoutée au panier. Elle sera automatiquement supprimée sous 2 jours si elle n'est pas validée.", "notif");
  }


  reset() {
    this.indexTaille = this.defaultIndex
    this.taille = this.article.taille
    this.selected = null
    this.selected_value = null
  }


  closeSlideBar() {
    this.router.navigate([
      {
        outlets: {
          sidebar: null,
          basket: null
        }
      }], {
      relativeTo: this.route.parent
    }).then(res => { this.sideBarService.close() }, error => { })
  }

  facturationTypeSB() {
    if (this.selected) {
      let change = this.changes.filter(value => this.selected == value.qte_semaine + '/' + value.qte_prevue + '|' + value.multi_change + ':' + value.type_facturation.cle_ref)[0]
      if (change != null && (change.type_facturation.cle_ref == 'S' || change.type_facturation.cle_ref == 'B')) {
        this.editDotationForm.controls["qteSouhaite"].setValidators([Validators.required])
        return true
      } else {
        this.editDotationForm.get('qteSouhaite').setValue(null)
        this.editDotationForm.controls["qteSouhaite"].clearValidators()
        return false
      }
    } else {
      this.editDotationForm.get('qteSouhaite').setValue(null)
      this.editDotationForm.controls["qteSouhaite"].clearValidators()
      return false
    }
  }

  editDotationForm: FormGroup = new FormGroup({
    'qteSouhaite': new FormControl('', [])
  })

}
